/**
 * Created by Andste on 2018/5/7.
 */

import Storage from './storage'
import * as API_Pages from '@/api/pages'
import * as API_Passport from '@/api/passport';
import * as API_Connect from '@/api/connect';
import { mapActions } from 'vuex';
import store from '../store';
import newV from '../main'

/**
 * 检查token：
 * 1. user/accessToken/refreshToken都不存在。
 *    表示用户没有登录，放行所有API
 * 2. 不存在accessToken，但是user/refreshToken存在。
 *    表示accessToken过期，需要重新获取accessToken。
 *    如果重新获取accessToken返回token失效错误，说明已被登出。
 * @param options
 * @returns {Promise<any>}
 */
 let getConnectUrl = API_Connect.getConnectUrl
//  ...mapActions({
//    login: 'user/loginAction',
//    mapActions.getCartData: 'cart/getCartDataAction',
//  }),
 function checkToken(options = true) {
  console.log(options,121)
  let  tp = ''
  options ? tp = true :  tp  = options 
  console.log(tp)
  try {
    if (window.GSShop_getChannel && typeof window.GSShop_getChannel == 'function') {
      // if (typeof(eval("GSShop_getChannel")) == "function") {
      Storage.setItem('isPublic','1')
      localStorage.setItem('isPublic','1')
      let channel = window.GSShop_getChannel();
      let clientType = '';
      if (channel == '10003') {
        clientType = 'FINANCIAL_VILLAGE_CLIENT';
      }
      let token = window.GSShop_getNativeToken();
      if (token == ''  ) {
        if(tp){
          console.log(tp,4444)
          window.GSShop_awakeLogin();
        }
      } else {
        //登陆
        let uuid = Storage.getItem('uuid');
        // document.getElementById('zyz2333').innerHTML = 'uuid ' + uuid;
        API_Passport.zyzAppLogin(uuid, token, clientType)
          .then(response => {
            // document.getElementById('zyz2334').innerHTML = JSON.stringify(response);
            // let a = {access_token:"eyJhbGciOiJIUzUxMiJ9.eyJ1aWQiOjE1NTUxMjgxNzQxMTE3OTcyNTAsInN1YiI6InVzZXIiLCJyb2xlcyI6WyJCVVlFUiJdLCJleHAiOjE2NTk2MTAwMjQsInV1aWQiOiI2NDQ0YzQ2MC0xM2RhLTExZWQtOGI2NS1mNTA0M2JlYWQyMTciLCJ1c2VybmFtZSI6Im1fYzQyODgwYjU0In0.bxbALCg8kGH-AlIEnwxQ-nQBcEsQFFmpN4C0P0aOcDAT5xbklyyJNYY3L_GF3HZ23W_BRMTi3eINJ9BJI6Ijaw",refresh_token :"eyJhbGciOiJIUzUxMiJ9.eyJ1aWQiOjE1NTUxMjgxNzQxMTE3OTcyNTAsInN1YiI6InVzZXIiLCJyb2xlcyI6WyJCVVlFUiJdLCJleHAiOjE2NTk2MTA2MjQsInV1aWQiOiI2NDQ0YzQ2MC0xM2RhLTExZWQtOGI2NS1mNTA0M2JlYWQyMTciLCJ1c2VybmFtZSI6Im1fYzQyODgwYjU0In0.ZTHDFLqEzVEp_uSS6qAHChuwCRUZ_r1QLICYbP5R0Hyb20bxEo80iJHNU6nHHjKAPJ16nIQVV3dlz3ACcOHmrQ",uid:"1555128174111797250"}
            newV.$store.dispatch('user/loginAction',{ login_type:'null', form: response})
              .then(async () => {
                console.log(uuid, token, clientType)
                await newV.$store.dispatch('cart/getCartDataAction');
                // document.getElementById('zyz2336').innerHTML = `${window.location.protocol}`;
                // window.location.href = '/';
              })
          }) 
          .catch(error => {
            console.log(error)
            // document.getElementById('zyz2335').innerHTML = '' + 'error' + error;
          });
      }
    }
  } catch (e) {
    
  }
  
}
export {
  checkToken
}



// WEBPACK FOOTER //
// ./src/utils/loginSetToken.js